import ActionCampaignCommunicationList from './ActionCampaignCommunicationList';

export default ActionCampaignCommunicationList;
